// Types
import { NewFeatureCarouselModalType } from 'Dashboard/components/NewFeatureCarouselModal/NewFeatureCarouselModal.types';

// Constants
import Colors from 'Wpds/colors/ColorConstants';
import { Illustrations } from 'Wpds/components/illustration';

export const Data = {
  slides: [
    {
      slug: 'qsg-complete-modal',
      title: 'Congrats - you’re set up for success!',
      imageBgColor: Colors.purple[25],
      image: Illustrations.person_with_confetti_falling_with_purple_bg,
      imageWidth: '200px',
      nextBtnLabel: 'Keep Looking Around',
      description: `When you’re done poking around, invite someone to start testing out PI Perform in meetings with.`,
    },
  ],
} as NewFeatureCarouselModalType;
